import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13 23.5h9V9a2 2 0 00-2-2h-5a2 2 0 00-2 2v14.5zm-6-7L1.5 11l9.086-9.086a2 2 0 012.828 0L18.5 7M13 21.5L6 19l5.257-13.143a2 2 0 012.6-1.114L19.5 7m-2 4.5a.5.5 0 100-1 .5.5 0 000 1z" stroke="#000" fill="none" fillRule="evenodd" /></svg>;